import React from 'react';

import { TableCell, withTooltip } from '@crossnokaye/ux-common';

import { PRIVILEGES } from '@/hooks/access/access-table';
import { useActionPermission } from '@/hooks/use-action-permission';

const TableCellWithTooltip = withTooltip(TableCell);

type DefrostTableCellProps = {
  children: (disabledByPermissions: boolean) => React.ReactNode;
};

export const DefrostTableCell = ({ children }: DefrostTableCellProps) => {
  const { isDisabled, tooltipText } = useActionPermission({
    privilege: PRIVILEGES.writeCommands,
  });

  return (
    <TableCellWithTooltip delayDuration={0} tooltipContent={isDisabled ? tooltipText : undefined}>
      {children(isDisabled)}
    </TableCellWithTooltip>
  );
};
